import React, { Component, Fragment } from 'react';

import './index.scss';

class AutoComplete extends Component {

    constructor(props) {
        super(props);
        this.state = {
            open : false,
            highlighted_item : -1,
        }
        this.handleClick        = this.handleClick.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.handleKeyUp        = this.handleKeyUp.bind(this);
        this.handleOptionClick  = this.handleOptionClick.bind(this);

        this.dropRef = React.createRef();
        this.inputRef = React.createRef();
        this.optionExampleRef = React.createRef();
    }

    handleClick(event) {

        //prevent form submission
        event.preventDefault();

        //fix for enter keyup event triggering click events - 0 = Enter key, 1 = click event
        if (!(event.detail === 0)) {
            let newState = !this.state.open;
            this.setState({open: newState});
        }
    }

    handleClickOutside() {
        this.setState({open: false});
    }

    handleKeyUp(event) {
        let highlighted_item   = this.state.highlighted_item;
        let highlighted_option = document.getElementsByClassName("highlight");
        let selected_option_id = -1;

        if(highlighted_option.length > 0) {
            selected_option_id = highlighted_option[0].getAttribute('id');
        }

        switch(event.key) {
            case('ArrowDown'): (highlighted_item + 1) > this.props.options.length -1 ?
                                    highlighted_item = 0
                                   :  highlighted_item++;
                               this.setState({highlighted_item: highlighted_item});
                               break;

            case('ArrowUp'):   (highlighted_item - 1) < 0 ?
                                    highlighted_item = this.props.options.length -1
                                   :  highlighted_item--;
                               this.setState({highlighted_item: highlighted_item});
                               break;

            case('Enter'):     if(this.state.open === false) {
                                    this.setState({open: true})
                               } else {
                                    let selected_item = this.props.options.find(option => parseInt(option.id) === parseInt(selected_option_id));
                                    this.props.onSelect(selected_item.id, selected_item.text);
                                    this.setState({open: false})
                                    this.inputRef.current.blur();
                               }
                               break;

            case('Escape'):    this.setState({highlighted_item: 0, open: false});
                               break;
            default:           this.setState({highlighted_item: -1});
                               break;

        }
    }

    handleOptionClick(event) {
        event.stopPropagation();
        event.preventDefault();

        this.inputRef.current.blur();

        this.setState({open: false});
        let selected_item  = this.props.options.find((item) => {
            return parseInt(item.id) === parseInt(event.target.id);
        });
        this.props.onSelect(selected_item.id, selected_item.text);
    }

    render() {
        const {
            options = [],
            selected_id = -1,
            label = '',
            sortByDefault = true,
            placeholder = 'autocomplete',
            disabled = false,
            className,
            tabIndex,
            onChange,
            onClear,
            always_active = false,
        } = this.props;
        let { query } = this.props;

        let activeClass = ((this.state.open && options.length >0) || always_active) ? 'active' : '';

        //filter and sort autocomplete options by query
        let filteredOptions = [];
        if(query === '') {
            filteredOptions = options;
            if(sortByDefault) {
                filteredOptions.sort((a,b) => {
                    return a.text > b.text ? 1 : -1;
                });
            }
        } else {
            filteredOptions = options.filter(option => option.text.toLowerCase().indexOf(query.toLowerCase()) !== -1);
            filteredOptions.sort((a,b) => {
                return a.text > b.text ? 1 : -1;
            });
        }

        //update window scroll top position
        if(this.dropRef.current){
            let current_scrolltop = this.dropRef.current.scrollTop;
            let drop_height   = this.dropRef.current?.clientHeight;
            let option_height = this.optionExampleRef.current?.clientHeight + 1;
            let highlight_position = (this.state.highlighted_item + 1) * option_height;

            let max_position = current_scrolltop + drop_height;
            let min_position = current_scrolltop + option_height;

            if(highlight_position > max_position || highlight_position < min_position) {
                this.dropRef.current.scrollTop = (this.state.highlighted_item + 1) * option_height - drop_height;
            }
        }

        //change query if id was selected externally
        if(selected_id !== -1) {
            let selected_item  = this.props.options.find((item) => {
                return parseInt(item.id) === parseInt(selected_id);
            });
            if(selected_item) {
                query = selected_item.text;
            }
        }

        return (
            <Fragment>
                { label !== '' && <label> { label }:</label> }
                <div className = {'auto_wrapper ' + className + ' ' + activeClass + (disabled ? ' disabled' : '')  }
                     tabIndex  = { tabIndex }
                     onBlur    = { this.handleClickOutside }
                     onKeyUp   = { this.handleKeyUp }>


                    <input className="auto-input"
                           name="autocomplete"
                           aria-label= { placeholder }
                           type = "text"
                           placeholder = { placeholder }
                           onClick = { (e) => this.handleClick(e) }
                           onChange = { (e) => onChange(e) }
                           value = { query }
                           ref= { this.inputRef }
                           autoComplete="off"
                    />

                    <ul className = 'auto-menu' ref={ this.dropRef }>
                        { filteredOptions.map((item, index) => {

                            let activeOption       = '';
                            let highlightedOption = '';

                            if(item.id === selected_id)
                            { activeOption = 'active' }

                            if(index === this.state.highlighted_item)
                            { highlightedOption = ' highlight'}

                            return (
                                <li className={ "auto_option " + activeOption + highlightedOption }
                                    key={ index }
                                    id={ item.id }
                                    onMouseDown={ this.handleOptionClick }>
                                    { item.text }
                                </li>
                            )
                        })}
                        {
                        //this option is for option height measurement only
                        }
                        <li className="auto_option example" ref={this.optionExampleRef}></li>
                    </ul>
                    {query !== '' &&
                        <div className="close-x" onClick={ onClear }></div>
                    }
                </div>
            </Fragment>
        )
    }
}
export default AutoComplete;


